import { Flex } from '@chakra-ui/layout';
import { jsx as _jsx } from "react/jsx-runtime";

var Loading = function Loading(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? '100vh' : _ref$height;
  return /*#__PURE__*/_jsx(Flex, {
    w: "100%",
    height: height,
    alignItems: "center",
    justify: "center",
    e2eid: "components_Loading_Flex",
    children: /*#__PURE__*/_jsx("img", {
      alt: "loading",
      src: "/loading.gif",
      width: "15%",
      e2eid: "components_Loading_img"
    })
  });
};

export default Loading;